export const MAGIC_INSIGHTS_CREDITS_FEATURE_NAME = 'Magic Insights Credits';

const LEGACY_MAGIC_INSIGHTS_FEATURE_NAMES = new Set([
  'Magic Insights Answer',
  'Magic Insights Unlock',
]);

export function normaliseManageQuotaFeatureName(
  featureName: string | undefined
): string {
  if (!featureName || LEGACY_MAGIC_INSIGHTS_FEATURE_NAMES.has(featureName)) {
    return MAGIC_INSIGHTS_CREDITS_FEATURE_NAME;
  }

  return featureName;
}

export interface CombinedQuotaBalance {
  assigned: number;
  usage: number;
  remaining: number;
}
